import {ErrorModel} from '../../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../../root';
import {grossMargin} from './defaultResponseModel/grossMargin';
const FUNCTION_CODE = 'GET_ALL_ADMIN_DASHBOARD_GROSS_MARGIN';

export async function getGrossMargin(userToken: string, params: string) {
    try {
        const response = await axios.get(
            `${URL}/dashboards/partner/gross-margin/${params}`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userToken}`
                }
            },
        );

        return grossMargin.from(response.data);
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
